import _ from 'lodash'

export default function accorCompleteDsp2Payment(
  cardNumber,
  dsp2Url,
  dsp2Payload,
  dsp2TransactionId,
  bookingId,
  // handleNextStep,
  handleSuccessfulReservation,
  handleDsp2TransactionSuccess,
  handleDsp2ApiError,
  hotelLabels
) {
  if (
    window.cardinal &&
    cardNumber !== '' &&
    dsp2Url &&
    dsp2Payload &&
    dsp2TransactionId
  ) {
    window.cardinal.trigger('bin.process', cardNumber.toString())
      .then(function(results) {
        if (results.Status === true) {
          window.cardinal.continue('cca',
            // A JSON object containing all the necessary data to complete a 3DS post to an ACS to complete a CCA transaction.
            {
              'AcsUrl': dsp2Url.toString(),
              'Payload': dsp2Payload.toString()

            },
            // A new order object to send to Centinel API
            {
              'OrderDetails': {
                'TransactionId': dsp2TransactionId.toString()
              }
            }
          )

          // An updated JWT to use while processing the transaction. This allows the merchant to switch JWT's between init and continue events
          window.cardinal.on('payments.validated', function(decodedResponseData, responseJWT) {
            const dsp2CancelledFlag = _.get(decodedResponseData, 'Payment.ExtendedData.ChallengeCancel', null)
            const isDsp2TransactionCancelled = dsp2CancelledFlag && dsp2CancelledFlag === '01' ? true : false

            if (
              !isDsp2TransactionCancelled &&
              bookingId &&
              responseJWT
            ) {
                handleSuccessfulReservation()
            } else if (isDsp2TransactionCancelled) {
                const errorMessage = _.get(hotelLabels, 'dsp2PaymentCancellationError', 'Transaction Cancelled (DSP2)')
                handleDsp2ApiError(errorMessage)
            } else {
                const errorMessage = _.get(hotelLabels, 'dsp2PaymentFailureError', 'Transaction Failed (DSP2)')
                handleDsp2ApiError(errorMessage)
            }
            handleDsp2TransactionSuccess(bookingId, responseJWT, handleDsp2ApiError)
          })
        } else {
          window.cardinal.off('payments.validated')
        }
      })
      .catch(function(error) {
        window.cardinal.off('payments.validated')
      })
  }
}


// WEBPACK FOOTER //
// ./src/utilities/payment/accorCompleteDsp2Payment.js